// ? If you need to change the values of the following, make sure to update the backend enum at /src/campaigns/enum/lead-source.enum.js.
// ? make sure the keys and values are same
// ? This object must always match the values defined in the backend to ensure consistency across the application.
export const LEAD_SOURCE = {
  MANUAL: 'Manual',
  GOOGLE_SHEET: 'Google_Sheet',
  CSV: 'CSV'
}
